import { useMemo } from "react";

const Locations = ({
  theme,
  data,
  handleChange,
  locations,
  onNextStep,
  onCancel,
}) => {
  const isDark = useMemo(() => theme === "dark", [theme]);
  return (
    <div>
      <h2
        className={`text-[24px] font-[600] text-center mb-4 ${
          theme === "dark" ? "text-[#92929D]" : ""
        }`}
        style={{ fontFamily: "var(--family-poppins)" }}
      >
        Compute Engine
      </h2>
      <div className="max-w-[650px] mx-auto">
        <h2
          className={`text-[24px] font-[600] mb-2 ${
            theme === "dark" ? "text-[#92929D]" : ""
          }`}
        >
          Location
        </h2>
        <p
          className={`text-sm ${
            isDark ? "text-[#92929D]" : "text-[#1d2433cc]"
          }`}
        >
          All servers are hosted within Tier 3/4 data centers and securely
          connected to our distributed compute network.
        </p>
        <div
          className={`flex flex-wrap gap-3 w-full mt-4 ${
            isDark ? "text-[#92929D]" : "text-[#1d2433cc]"
          }`}
        >
          {locations?.map((itm) => (
            <div
              key={itm?._id}
              onClick={() => handleChange("location", itm)}
              className={`border-[1px] w-[32%] max-[942px]:w-[48%] max-[475px]:w-[100%] text-sm border-solid ${
                data?.location?._id === itm?._id
                  ? "border-black"
                  : "border-[#e1e6ef]"
              } rounded-[8px] p-[11px] cursor-pointer`}
            >
              {itm?.city} . {itm?.country}
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-3 mt-3">
          <button
            className={`font-[600] py-[7px] w-fit rounded-[8px] px-[20px] text-[#141416] bg-white border-[1px] border-solid`}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            disabled={!data?.location}
            className={`font-[600] py-[7px] w-fit rounded-[8px] px-[20px] text-white ${
              isDark ? "bg-[#818181]" : "bg-[#141416]"
            }`}
            onClick={onNextStep}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default Locations;
